import React from 'react';
import { InfoBanner as Banner } from '@sparknz/spark-pattern-library';
import { LinkRegion } from '@sparknz/tracking';

import extractCQStyle, { CQStyleMap } from 'shared/utils/extractCQStyle';
import {
  InfoBannerConfigProps,
  InfoBannerEditConfig,
} from './InfoBannerEditConfig';

export type InfoBannerProps =
  | 'ERROR'
  | 'INFO'
  | 'SUCCESS'
  | 'WARN'
  | 'IMPORTANT';

const infoBannerPropCQStyleMap: CQStyleMap<InfoBannerProps> = {
  error: 'ERROR',
  info: 'INFO',
  success: 'SUCCESS',
  warn: 'WARN',
  important: 'IMPORTANT',
};

const InfoBanner = (props: InfoBannerConfigProps) => {
  const {
    text,
    appliedCssClassNames: cssClassNames,
    buttonText,
    onClick,
    regionId = 'infobanner',
    children,
  } = props;

  if (InfoBannerEditConfig.isEmpty(props)) {
    return null;
  }

  const infoBannerStyle =
    extractCQStyle(infoBannerPropCQStyleMap, cssClassNames) || 'INFO';

  return (
    <LinkRegion regionId={regionId}>
      <Banner
        children={children}
        variant={infoBannerStyle}
        text={text}
        buttonText={buttonText}
        componentAs="a"
        href={onClick}
      />
    </LinkRegion>
  );
};

export default InfoBanner;
